// Sport Fitt Pro - Sports Gear & Fitness Equipment
// High-converting modern sport brand with bold energetic design

// ============================================
// SITE IMAGES - Sports & Fitness Lifestyle
// ============================================
export const siteImages = {
  // Hero images - bold athletic visuals (gym + outdoor training)
  heroMain: 'https://images.unsplash.com/photo-1605296867304-46d5465a13f1?w=1920&q=80',
  heroSecondary: 'https://images.unsplash.com/photo-1601422407692-ec4eeec1d9b3?w=1920&q=80',
  heroLifestyle: 'https://images.pexels.com/photos/36120641/pexels-photo-36120641.png?w=1920',

  // Section backgrounds
  ctaBackground: 'https://images.unsplash.com/photo-1601422407692-ec4eeec1d9b3?w=1920&q=80',
  featuredBackground: 'https://images.unsplash.com/photo-1722925541311-2117dfa21fe3?w=1920&q=80',
  powerBackground: 'https://images.pexels.com/photos/31849599/pexels-photo-31849599.jpeg?w=1920',
  lifestyleOutdoor: 'https://images.unsplash.com/photo-1595078475328-1ab05d0a6a0e?w=1920&q=80',
  lifestyleGym: 'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=1920&q=80',

  // Page banners - sports lifestyle, gym + outdoor scenes, energetic
  shopBanner: 'https://images.unsplash.com/photo-1674834727206-4bc272bfd8da?w=1920&q=80',
  aboutBanner: 'https://images.pexels.com/photos/31849599/pexels-photo-31849599.jpeg?w=1920',
  contactBanner: 'https://images.unsplash.com/photo-1604480133080-602261a680df?w=1920&q=80',
  returnsBanner: 'https://images.pexels.com/photos/13863730/pexels-photo-13863730.jpeg?w=1920',
  privacyBanner: 'https://images.unsplash.com/photo-1605296867304-46d5465a13f1?w=1920&q=80',
  productBanner: 'https://images.unsplash.com/photo-1517836357463-d25dfeac3438?w=1920&q=80',
  categoryBanner: 'https://images.unsplash.com/photo-1517963879433-6ad2b056d712?w=1920&q=80',
};

// ============================================
// PLACEHOLDER PRODUCT IMAGES
// ============================================
const productImages = {
  placeholder: 'https://placehold.co/1200x1200/0B0E1A/FF4D1A?text=Product+Image',
};

// Category placeholder images with brand accent
const categoryImages = {
  smartWearables: 'https://placehold.co/1200x1200/0B0E1A/FF4D1A?text=Smart+Wearables',
  homeWorkout: 'https://placehold.co/1200x1200/0B0E1A/FF4D1A?text=Home+Workout',
  strengthTraining: 'https://placehold.co/1200x1200/0B0E1A/FF4D1A?text=Strength+Training',
  recovery: 'https://placehold.co/1200x1200/0B0E1A/FF4D1A?text=Recovery',
  running: 'https://placehold.co/1200x1200/0B0E1A/FF4D1A?text=Running+Tech',
  outdoor: 'https://placehold.co/1200x1200/0B0E1A/FF4D1A?text=Outdoor+Gear',
  cycling: 'https://placehold.co/1200x1200/0B0E1A/FF4D1A?text=Cycling+Gadgets',
  training: 'https://placehold.co/1200x1200/0B0E1A/FF4D1A?text=Training+Accessories',
};

export const SHIPPING_NOTICE = 'We ship within the USA via USPS';
export const SHIPPING_COUNTRIES = ['US'];
export const SHIPPING_METHOD = 'USPS';
export const SHIPPING_TIME = '3-5 business days';
export const FREE_SHIPPING_THRESHOLD = 75;

// Card Statement Descriptor
export const CARD_DESCRIPTOR = 'SPORT FITT PRO';

// Hosting Provider
export const HOSTING_PROVIDER = 'Hostinger';

// Contact Info - Sport Fitt Pro
export const CONTACT_INFO = {
  phone: '(866) 658-1452',
  email: 'support@sportfittpro.com',
  corpName: 'JMP AD GROUP LLC',
  address: {
    street: '130 Stevenson Dr',
    city: 'Glendale Heights',
    state: 'IL',
    zip: '60139',
    country: 'USA'
  }
};

// Return Address
export const RETURN_ADDRESS = {
  street: '555 Remington Blvd., Ste B',
  city: 'Bolingbrook',
  state: 'IL',
  zip: '60440',
  country: 'USA'
};

// ============================================
// CATEGORIES - 7 Fitness Equipment Categories
// ============================================
export const categories = [
  {
    id: 'smart-wearables',
    name: 'Smart Wearables',
    slug: 'smart-wearables',
    description: 'Track activity, heart rate, and daily performance metrics',
    image: categoryImages.smartWearables,
    productCount: 1
  },
  {
    id: 'home-workout-gear',
    name: 'Home Workout Gear',
    slug: 'home-workout-gear',
    description: 'Efficient home workout equipment for targeted training',
    image: categoryImages.homeWorkout,
    productCount: 1
  },
  {
    id: 'strength-training-tools',
    name: 'Strength Training Tools',
    slug: 'strength-training-tools',
    description: 'Smart tools to monitor and improve strength progress',
    image: categoryImages.strengthTraining,
    productCount: 1
  },
  {
    id: 'recovery-equipment',
    name: 'Recovery Equipment',
    slug: 'recovery-equipment',
    description: 'Support muscle recovery and reduce fatigue after workouts',
    image: categoryImages.recovery,
    productCount: 1
  },
  {
    id: 'running-tech',
    name: 'Running Tech',
    slug: 'running-tech',
    description: 'Lightweight gear for hands-free running and workouts',
    image: categoryImages.running,
    productCount: 1
  },
  {
    id: 'outdoor-fitness-gear',
    name: 'Outdoor Fitness Gear',
    slug: 'outdoor-fitness-gear',
    description: 'Durable equipment for outdoor sports and endurance training',
    image: categoryImages.outdoor,
    productCount: 1
  },
  {
    id: 'cycling-gadgets',
    name: 'Cycling Gadgets',
    slug: 'cycling-gadgets',
    description: 'Secure and convenient accessories for cycling',
    image: categoryImages.cycling,
    productCount: 1
  },
  {
    id: 'training-accessories',
    name: 'Training Accessories',
    slug: 'training-accessories',
    description: 'Essential gear for balance, stability, and coordination',
    image: categoryImages.training,
    productCount: 1
  }
];

// ============================================
// PRODUCTS - 8 Fitness Gadgets (1 per category)
// ============================================
export const products = [
  // ========== SMART WEARABLES ==========
  {
    id: 'smart-fitness-tracker-band-pro',
    name: 'Smart Fitness Tracker Band Pro',
    slug: 'smart-fitness-tracker-band-pro',
    sku: 'CAF-SW-001',
    price: 49.99,
    image: 'https://i01.appmifile.com/webfile/globalimg/products/m/redmi-smart-band-pro/section01-02.png',
    badge: 'Best Seller',
    categoryId: 'smart-wearables',
    categorySlug: 'smart-wearables',
    description: 'Advanced wearable designed to track activity, heart rate, and daily performance metrics for active lifestyles.',
    keyBenefits: [
      'Activity & heart rate tracking',
      'Daily performance metrics',
      'Sleek wearable design'
    ],
    usage: 'Wear throughout the day to monitor your fitness metrics and track your progress.',
    features: ['Heart Rate Monitor', 'Step Counter', 'Sleep Tracking', 'Water Resistant'],
    inStock: true
  },

  // ========== HOME WORKOUT GEAR ==========
  {
    id: 'smart-push-up-board-system',
    name: 'Smart Push-Up Board System',
    slug: 'smart-push-up-board-system',
    sku: 'CAF-HW-001',
    price: 34.99,
    image: 'https://m.media-amazon.com/images/I/61vGxHGejnL._AC_UF894,1000_QL80_.jpg',
    badge: 'Popular',
    categoryId: 'home-workout-gear',
    categorySlug: 'home-workout-gear',
    description: 'Color-coded push-up board designed to target different muscle groups for efficient home workouts.',
    keyBenefits: [
      'Color-coded targeting system',
      'Multiple muscle group focus',
      'Compact home design'
    ],
    usage: 'Follow the color-coded positions to target chest, shoulders, back, and triceps effectively.',
    features: ['Color-Coded System', 'Multiple Positions', 'Non-Slip Base', 'Portable Design'],
    inStock: true
  },

  // ========== STRENGTH TRAINING TOOLS ==========
  {
    id: 'adjustable-digital-grip-strength-trainer',
    name: 'Adjustable Digital Grip Strength Trainer',
    slug: 'adjustable-digital-grip-strength-trainer',
    sku: 'CAF-ST-001',
    price: 27.99,
    image: 'https://m.media-amazon.com/images/I/61Quyd1u7ML._AC_UF1000,1000_QL80_.jpg',
    badge: 'New',
    categoryId: 'strength-training-tools',
    categorySlug: 'strength-training-tools',
    description: 'Smart grip trainer with digital tracking to monitor strength progress and endurance.',
    keyBenefits: [
      'Digital strength tracking',
      'Adjustable resistance levels',
      'Progress monitoring'
    ],
    usage: 'Adjust resistance to your level and track your grip strength improvements over time.',
    features: ['Digital Display', 'Adjustable Resistance', 'Rep Counter', 'Ergonomic Grip'],
    inStock: true
  },

  // ========== RECOVERY EQUIPMENT ==========
  {
    id: 'portable-cold-therapy-recovery-wrap',
    name: 'Portable Cold Therapy Recovery Wrap',
    slug: 'portable-cold-therapy-recovery-wrap',
    sku: 'CAF-RE-001',
    price: 44.99,
    image: 'https://m.media-amazon.com/images/I/51f85tidWHL._AC_UF1000,1000_QL80_.jpg',
    badge: 'Top Rated',
    categoryId: 'recovery-equipment',
    categorySlug: 'recovery-equipment',
    description: 'Designed to support muscle recovery and reduce fatigue after intense workouts.',
    keyBenefits: [
      'Cold therapy support',
      'Muscle recovery aid',
      'Fatigue reduction'
    ],
    usage: 'Apply to sore muscles after workouts for 15-20 minutes to support recovery.',
    features: ['Cold Therapy', 'Adjustable Fit', 'Portable Design', 'Reusable'],
    inStock: true
  },

  // ========== RUNNING TECH ==========
  {
    id: 'wireless-running-arm-phone-holder',
    name: 'Wireless Running Arm Phone Holder',
    slug: 'wireless-running-arm-phone-holder',
    sku: 'CAF-RT-001',
    price: 19.99,
    image: 'https://i.ebayimg.com/images/g/eTcAAOSw6yBgxe~g/s-l1200.png',
    badge: 'Essential',
    categoryId: 'running-tech',
    categorySlug: 'running-tech',
    description: 'Lightweight and secure arm band for hands-free running and workout sessions.',
    keyBenefits: [
      'Secure phone hold',
      'Hands-free design',
      'Lightweight comfort'
    ],
    usage: 'Strap to your arm securely and enjoy hands-free access to your phone during workouts.',
    features: ['Universal Fit', 'Sweat Resistant', 'Key Pocket', 'Reflective Strips'],
    inStock: true
  },

  // ========== OUTDOOR FITNESS GEAR ==========
  {
    id: 'multi-function-tactical-hydration-backpack',
    name: 'Multi-Function Tactical Hydration Backpack',
    slug: 'multi-function-tactical-hydration-backpack',
    sku: 'CAF-OF-001',
    price: 59.99,
    image: 'https://m.media-amazon.com/images/I/81e-25t3XSL._AC_UF1000,1000_QL80_.jpg',
    badge: 'Premium',
    categoryId: 'outdoor-fitness-gear',
    categorySlug: 'outdoor-fitness-gear',
    description: 'Durable backpack with hydration system, ideal for outdoor sports and endurance training.',
    keyBenefits: [
      'Built-in hydration system',
      'Durable construction',
      'Multi-pocket design'
    ],
    usage: 'Fill the hydration bladder and wear during outdoor activities for convenient water access.',
    features: ['2L Hydration Bladder', 'Multiple Compartments', 'Water Resistant', 'Adjustable Straps'],
    inStock: true
  },

  // ========== CYCLING GADGETS ==========
  {
    id: 'smart-bike-phone-mount-shock-absorption',
    name: 'Smart Bike Phone Mount with Shock Absorption',
    slug: 'smart-bike-phone-mount-shock-absorption',
    sku: 'CAF-CG-001',
    price: 24.99,
    image: 'https://m.media-amazon.com/images/I/61fC18PiL9L._AC_UF1000,1000_QL80_.jpg',
    badge: 'Popular',
    categoryId: 'cycling-gadgets',
    categorySlug: 'cycling-gadgets',
    description: 'Secure phone mount designed for stability and convenience during cycling.',
    keyBenefits: [
      'Shock absorption system',
      'Secure phone grip',
      '360° rotation'
    ],
    usage: 'Attach to your bike handlebar and secure your phone for navigation and tracking.',
    features: ['Shock Absorption', '360° Rotation', 'Universal Fit', 'Quick Release'],
    inStock: true
  },

  // ========== TRAINING ACCESSORIES ==========
  {
    id: 'non-slip-core-stability-disc',
    name: 'Non-Slip Core Stability Disc',
    slug: 'non-slip-core-stability-disc',
    sku: 'CAF-TA-001',
    price: 21.99,
    image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQjB3oILPJOGeimrJKaWQvAB241Wb9-gBoEjQ&s',
    categoryId: 'training-accessories',
    categorySlug: 'training-accessories',
    description: 'Balance training disc designed to improve core strength, stability, and coordination.',
    keyBenefits: [
      'Core strength building',
      'Balance improvement',
      'Coordination training'
    ],
    usage: 'Stand or sit on the disc during exercises to engage core muscles and improve balance.',
    features: ['Non-Slip Surface', 'Durable PVC', 'Portable', 'Multi-Use'],
    inStock: true
  }
];

// ============================================
// FEATURES / WHY CHOOSE US
// ============================================
export const features = [
  {
    id: 1,
    title: 'Quality Gear',
    description: 'Performance-tested fitness equipment for serious athletes'
  },
  {
    id: 2,
    title: 'Fast USA Shipping',
    description: 'Free shipping on orders over $75'
  },
  {
    id: 3,
    title: '30-Day Returns',
    description: 'Hassle-free returns on all products'
  },
  {
    id: 4,
    title: 'Secure Checkout',
    description: 'Your payment info is always protected'
  }
];

// ============================================
// PERFORMANCE BENEFITS
// ============================================
export const performanceBenefits = [
  {
    id: 1,
    title: 'Strength',
    description: 'Build power and muscle with targeted training tools'
  },
  {
    id: 2,
    title: 'Endurance',
    description: 'Push your limits with gear designed for lasting performance'
  },
  {
    id: 3,
    title: 'Recovery',
    description: 'Bounce back faster with advanced recovery equipment'
  },
  {
    id: 4,
    title: 'Mobility',
    description: 'Enhance flexibility and movement with balance training'
  }
];

// ============================================
// STEPS (How it works)
// ============================================
export const steps = [
  {
    id: 1,
    title: 'Browse Gear',
    description: 'Explore our curated selection of fitness equipment.'
  },
  {
    id: 2,
    title: 'Choose Your Tools',
    description: 'Select the perfect gear for your training goals.'
  },
  {
    id: 3,
    title: 'Secure Checkout',
    description: 'Complete your purchase with confidence.'
  },
  {
    id: 4,
    title: 'Train Smarter',
    description: 'Receive your gear and elevate your performance!'
  }
];
